import { render, staticRenderFns } from "./TrendingAnime.vue?vue&type=template&id=d7019614&scoped=true&"
import script from "./TrendingAnime.vue?vue&type=script&lang=js&"
export * from "./TrendingAnime.vue?vue&type=script&lang=js&"
import style0 from "./TrendingAnime.vue?vue&type=style&index=0&id=d7019614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7019614",
  null
  
)

export default component.exports